import { render, staticRenderFns } from "./LowerPart.vue?vue&type=template&id=4e1077ba&scoped=true&"
import script from "./LowerPart.vue?vue&type=script&lang=js&"
export * from "./LowerPart.vue?vue&type=script&lang=js&"
import style0 from "./LowerPart.vue?vue&type=style&index=0&id=4e1077ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1077ba",
  null
  
)

export default component.exports